import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const qualifiers = ['Tenés escoliosis, hipercifosis, hiperlordosis o rectificación cervical', 'Sos adolescente recién diagnosticado o adulto con años de dolor crónico', 'Querés rutinas que puedas hacer en casa, sin equipamiento especial', 'Necesitás entender qué le pasa a tu columna, no solo seguir instrucciones ciegas', 'Querés complementar tus sesiones de kinesiología con trabajo en casa', 'No tenés tiempo para ir al gimnasio pero sí 20 minutos por día para invertir en tu espalda'];
export function Qualifier() {
  return <section className="py-14 md:py-24 bg-white" data-id="element-326">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <div className="text-center mb-10 md:mb-16" data-id="element-328">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-329">
            Esto es para vos si...
          </h2>
          <div className="w-24 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-330"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-331">
          {qualifiers.map((qualifier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 bg-slate-50 rounded-xl border border-slate-100" data-id="element-332">
              <CheckCircle2Icon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-333" />
              <p className="text-sm md:text-base text-slate-700 font-medium" data-id="element-334">
                {qualifier}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}